import { withBlockExtensions } from '@plone/volto/helpers';
import { MPFSectionHeading } from 'volto-ministerio-publico-federal/components/UI';

interface SectionHeadingData {
  title?: string;
}

const MpfSectionHeadingBlockView = ({ data }: { data: SectionHeadingData }) =>
  data?.title ? <MPFSectionHeading title={data.title} /> : null;

export default withBlockExtensions(MpfSectionHeadingBlockView);
